import { Directive, ElementRef, Input, OnChanges, OnInit, Optional, Renderer2, SimpleChanges } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { DataService } from 'src/app/services/data/data.service';
import { UtilService } from '../services';
import { Permission } from '../models';
import { MatTab, MatTabLink } from '@angular/material/tabs';

@Directive({
  selector: '[hasPermission]'
})
export class PermissionDirective implements OnInit, OnChanges {

  @Input() hasPermission?: Permission;
  @Input() disabledOption1?: { condition: boolean, message?: string };
  @Input() disabledOption2?: { condition: boolean, message?: string };
  isDisabled: boolean = false;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private dataService: DataService,
    private util: UtilService,
    @Optional() private matButton: MatButton,
    @Optional() private matTab: MatTab,
    @Optional() private matTabLink: MatTabLink
  ) {

    this.dataService.permissionsUpdated.subscribe({
      next: (data: any) => {
        this.updateButtonState();
      }
    })
  }
  ngOnInit(): void {
    // console.log("Permission Directive", this.hasPermission, this.disabledOption1, this.disabledOption2)
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updateButtonState();
  }

  private updateButtonState(): void {
    if (!!this.hasPermission) {

      let isDisalbedDueToPermissions = this.util.hasPermission(this.hasPermission) == false;
      this.isDisabled = isDisalbedDueToPermissions ||
                        (this.disabledOption1?.condition ?? false) ||
                        (this.disabledOption2?.condition ?? false);

      if (!!this.matButton) {
        this.matButton.disabled = this.isDisabled; 
      }
      else if (!!this.matTab) {
        this.matTab.disabled = this.isDisabled;
      }
      else if (!!this.matTabLink) {
        this.matTabLink.disabled = this.isDisabled;
        // console.log("ELEMENT", this.matTabLink.elementRef.nativeElement)
      }

      
      const host = this.el.nativeElement;
      // console.log("HOST", host, this.matButton, this.matTab, this.matTabLink)
      if (!!host) {
        if (isDisalbedDueToPermissions) {
          this.renderer.setAttribute(host, 'title', 'You do not have permissions' + (this.dataService.debugMode ? ` ${this.hasPermission}` : ''));
          this.renderer.setStyle(host, 'cursor', 'not-allowed');
        }
        else {
          if (!!this.disabledOption1 && this.disabledOption1.condition === true) {
            this.renderer.setAttribute(host, 'title', this.disabledOption1?.message || 'Disabled');
            this.renderer.setStyle(host, 'cursor', 'not-allowed');
          }
          else if (!!this.disabledOption2 && this.disabledOption2.condition === true) {
            this.renderer.setAttribute(host, 'title', this.disabledOption2?.message || 'Disabled');
            this.renderer.setStyle(host, 'cursor', 'not-allowed');
          }
          else {
            this.renderer.removeAttribute(host, 'title');
            this.renderer.setStyle(host, 'cursor', 'pointer');
          }
        }
      }
    }
  }
}
